import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment/environment';
import { APIuuid, IAPIArrayData, IAPIData } from '@shared/interfaces/api.interface';
import { ICustomNotification } from '@shared/interfaces/custom-notification.interface';
import { CustomNotification } from '@shared/models/custom-notification.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Team-notification rows of the Notifications settings matrix
 * (`/api/v3/custom_notifications`): one row per event, the recipient columns
 * as `send_to_*` flags, `custom_emails` as an array.
 */
@Injectable({
  providedIn: 'root'
})
export class CustomNotificationsService {
  private readonly ENDPOINT_V3: string = String(
    `${environment.ENDPOINTS.BACK_END.V3}/custom_notifications`
  );

  constructor(private readonly _http: HttpClient) {}

  /** Every event row of the caller's firm (or of a firm in its family). */
  public list(hiringFirmId?: APIuuid): Observable<ICustomNotification[]> {
    let params: HttpParams = new HttpParams();
    if (hiringFirmId) {
      params = params.set('hiring_firm_id', String(hiringFirmId));
    }

    return this._http
      .get<IAPIArrayData>(this.ENDPOINT_V3, { params })
      .pipe(map((res: IAPIArrayData) => CustomNotification.fromAPIArray(res)));
  }

  /** Partial update of one row: only the attributes passed are changed. */
  public patch(
    id: APIuuid,
    attributes: Partial<ICustomNotification>
  ): Observable<ICustomNotification> {
    const body: IAPIData = {
      data: { type: CustomNotification.TYPE, id, attributes }
    } as IAPIData;

    return this._http
      .patch<IAPIData>(`${this.ENDPOINT_V3}/${id}`, body)
      .pipe(map((res: IAPIData) => CustomNotification.fromAPI(res)));
  }
}
